<template>
  <div class="header-text">
    <img alt="METRO" src="../assets/METRO.svg" />
    app
  </div>
</template>

<style scoped>
.header-text {
  background-color: var(--el-color-primary);
  color: var(--el-color-yellow);
}
</style>
